import { render, staticRenderFns } from "./FieldTooltip.vue?vue&type=template&id=4f8ed4c3&"
import script from "./FieldTooltip.vue?vue&type=script&lang=ts&"
export * from "./FieldTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports